import PropTypes from 'prop-types'
import React from 'react'
import styles from 'layouts/WideLayout/WideLayout.module.scss'
import { CloseButton } from 'layouts/WideLayout/subcomponents'
import Header from 'components/Header'
import { Grid } from 'gu-ui-kit'
import clsx from 'clsx'
import Footer from 'components/Footer'
import findMatchedRoutes from 'utils/findMatchedRoutes'

const WideLayout = ({ children = null, onClose = () => global.history.go(-1) }) => {
  const matchedRoutes = findMatchedRoutes()

  return (
    <Grid
      component={'section'}
      className={styles['layout']}
      direction={'column'}
      wrap={false}
    >
      <Grid
        direction={'row'}
        fluid
        wrap={false}
        className={styles['layout__header-container']}
        gap={8}
      >
        <Grid className={styles['layout__header']}>
          <Header noToggler={true} />
        </Grid>

        <CloseButton onClose={onClose} />
      </Grid>

      <Grid
        className={styles['layout__content']}
        wrap={false}
        direction={'column'}
      >
        <Grid
          className={clsx({
            'layout-tile': !matchedRoutes.at(-1).restyled,
          })}
          alignSelf={'start'}
          wrap={false}
          direction={'column'}
        >
          {children}
        </Grid>
      </Grid>
      <Footer wide />
    </Grid>
  )
}

WideLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
  //@TODO позже удаляем пропс когда все формы красиво разделим на layout-tile
}

export default WideLayout
